<template>
  <div>
    <index-navbar />

    <!-- <LaunchDate /> -->

    <section
      class="header pt-12 relative pb-2 mt-12 lg:px-16 block bg-dark-bgbb100">
      <div class="container">
        <div class="flex flex-wrap">
          <div class="w-full md:w-6/12 px-4 text-left">
            <div class="px-4 pb-6 lg:pt-20 flex-auto">
              <h2 class="text-3xl text-white">
                The Smartest Way to Earn Crypto <br />
                & Help a Cause at The Same Time
              </h2>
              <p class="mt-4 text-lg leading-relaxed text-white text-justify">
                <span class="text-bgbb-y">
                  <strong
                    >BGBB is redifining DeFi by creating a pure financial
                    ecosystem.</strong
                  >
                </span>
                Specializing in creating interest through staking, the BGBB
                contract earns investors money from the safety of their private
                wallets while also providing a massive liquidity pool to cash
                out gains. <br />

                <i
                  >If you are looking for the best way to earn crypto, you are
                  in the right place.</i
                >
              </p>
              <div class="flex flex-wrap text-center pt-6">
                <a
                  href="/overview"
                  target="_self"
                  class="shadow-2xl font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white text-sm"
                >
                  Overview <i class="fas fa-long-arrow-alt-right"></i>
                </a>
                <a
                  href="https://github.com/BGBB-token/papers/raw/main/Technical_Paper_V2.0.pdf"
                  class="shadow-2xl ml-1 font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbbnav text-sm"
                  target="_self"
                  >Technical Paper
                </a>
              </div>
            </div>
          </div>

          <div class="w-full md:w-6/12 px-4 text-center">
            <div class="flex-auto">
              <img
                class="align-middle border-none max-w-full h-auto rounded-lg"
                :src="earnandhelp_img"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="mobilep pt-24 sm:pt-0">
            <h2 class="text-3xl text-white">BGBB Token</h2>
            <p class="text-2xl text-white font-light">
              The Smartest Way to Earn Crypto & Help a Cause
            </p>

            <p class="mt-4 text-lg leading-relaxed text-white text-justify">
              <span class="text-bgbb-y">
                <strong
                  >BGBB is redifining DeFi by creating a pure financial
                  ecosystem.</strong
                >
              </span>
              Specializing in creating interest through staking, the BGBB
              contract earns investors money from the safety of their private
              wallets while also providing a massive liquidity pool to cash out
              gains. <br />
              <br />
              <i
                >If you are looking for the best way to earn crypto, you are in
                the right place.</i
              >
            </p>
            <div class="mt-12 mb-24"></div>
            
          </div>
        </div>
      </div> -->
    </section>

    <section class="pb-20 relative block bg-bgbb-y">
      <!-- DIVER 1 -->
      <div class="custom-shape-divider-top-1623755832">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>

      <!-- DIVER 1 -->

      <div class="container mx-auto md:px-4 lg:pt-24 lg:pb-10">
        <div class="w-full lg:w-12/12 px-8">
          <h2 class="text-4xl text-white text-center mobile:pt-32">BGBB Overview</h2>
        </div>
        <div class="flex flex-wrap text-center justify-center">
          <div class="flex flex-wrap text-center justify-center mt-12"></div>

          <section class="pb-20 mt-12">
            <div class="container mx-auto px-4">
              <div class="flex flex-wrap">
                <div class="w-full md:w-4/12 px-4 text-center">
                  <div
                    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-2xl rounded-lg"
                  >
                    <div class="px-4 py-5 flex-auto">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-bgbb-1"
                      >
                        <i class="fas fa-shopping-cart"></i>
                      </div>

                      <br />
                      <h6 class="text-xl">Reserve BGBB</h6>
                      <p class="mt-2 mb-4 text-gray-600">
                        BGBB has a 50 day launch period for investors to reserve
                        BGBB. Each day of launch, about 5 Million BGBB are
                        available which are distributed proportionally according
                        to the amount of total ADA sent for the day.
                        <br />
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-4/12 px-4 text-center">
                  <div
                    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-2xl rounded-lg"
                  >
                    <div class="px-4 py-5 flex-auto">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-bgbb-2"
                      >
                        <i class="fas fa-hourglass-half"></i>
                      </div>
                      <br />
                      <h6 class="text-xl">Stake BGBB</h6>
                      <p class="mt-2 mb-4 text-gray-600">
                        Lock up your BGBB in order to earn interest over the
                        duration. The longer you stake the more interest you
                        earn. You may withdraw interest at any time for no fee,
                        but ending a stake early penalizes the principal. All
                        fees and penalties are redistributed to other stakers.
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-4/12 px-4 text-center">
                  <div
                    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-2xl rounded-lg"
                  >
                    <div class="px-4 py-5 flex-auto">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 rounded-full bg-bgbb-y"
                      >
                        <i class="fas fa-exchange-alt"></i>
                      </div>
                      <br />
                      <h6 class="text-xl">Sell BGBB</h6>
                      <p class="mt-2 mb-4 text-gray-600">
                        Cash out instantly using SundaeSwap. While other projects
                        rely on users to slowly build market for their tokens,
                        the very nature of the BGBB contract includes the
                        instant creation of a massive pool of liquidity on
                        SundaeSwap, featuring no KYC and the ability to swap from
                        your wallet.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="w-full lg:w-12/12 lg:px-12 mobile:px-8">
          <h2 class="text-3xl text-bgbb-dark md:px-4">BGBB Smart Contracts</h2>

          <p class="text-dark-bgbb100 text-justify text-lg md:px-4">
            The BGBB project consists of smart contracts capitalizing on token
            liquidity fromation, a referral system and token staking
            capabilities which are explained in the

            <a href="https://github.com/BGBB-token/papers/raw/main/Technical_Paper_V2.0.pdf" class="underline">Technical Paper</a>. The overall flow of the BGBB
            project can be described in <strong>two main epochs</strong> - each
            developed as smart contract for specific dinanciial purpose.
          </p>

          <section class="pb-20 mt-12 ">
            <div class="container mx-auto">
              <div class="flex flex-wrap">
                <div class="w-full md:w-6/12 md:px-4 text-center">
                  <div
                    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
                  >
                    <div class="px-4 py-5 flex-auto">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-2xl rounded-full bg-bgbb-y2"
                      >
                        <i class="fas fa-exchange-alt"></i>
                      </div>
                      <br />
                      <h6 class="text-xl">Liquidity Transform Epoch</h6>
                      <p class="mt-2 mb-4 text-gray-600">
                        The launch of the BGBB contrack will kick off an initial
                        50 day phase during which users may send ADA to the
                        contract in order to reserce BGBB tokens and form main
                        liquidity pool.
                      </p>

                      <div
                        class="flex flex-wrap text-center justify-center mt-8"
                      >
                        <a
                          href="#"
                          target="_self"
                          class="shadow-xl font-semibold px-6 py-4 rounded outline-none focus:outline-none bg-bgbb-y text-base container2 text-bg-bgbb100"
                        >
                          Reserve BGBB
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-6/12 md:px-4 text-center">
                  <div
                    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
                  >
                    <div class="px-4 py-5 flex-auto">
                      <div
                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-2xl rounded-full bg-bgbb-y"
                      >
                        <i class="fas fa-exchange-alt"></i>
                      </div>
                      <br />
                      <h6 class="text-xl">Circulation Epoch</h6>
                      <p class="mt-2 mb-4 text-gray-600">
                        At this point, no further reservations can be made.
                        Reserved BGBB and referred bonus BGBB may now be minted
                        by users at their leisure. Users may begin staking BGBB.
                      </p>

                      <div
                        class="flex flex-wrap text-center justify-center mt-8"
                      >
                        <a
                          href="#"
                          target="_self"
                          class="shadow-xl font-semibold px-6 py-4 rounded outline-none focus:outline-none bg-bgbb-y2 text-base container2 text-white"
                        >
                          Stake BGBB
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="custom-shape-divider-bottom-1623757940">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </section>

    <section class="pb-20 mt-12  lg:px-16 mobile:px-4">
      <div class="container">
        <div class="flex flex-wrap">
          <div class="w-full md:w-6/12 px-4 text-center">
            <div class="flex-auto">
              <img
                class="align-middle border-none max-w-full h-auto rounded-lg"
                :src="LT_img"
              />
            </div>
          </div>

          <div class="w-full md:w-6/12 md:px-4 text-left">
            <div class="px-4 py-5 flex-auto">
              <h2 class="text-3xl text-white">Liquidity Transform Epoch</h2>

              <p
                class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify mb-12"
              >
                This component of the BGBB project trustlessly generates the
                main liquidity pool for BGBB using the SundaeSwap protocol. BGBB
                tokens are minted to investors who make reservations with ADA,
                and the ADA is paired with more BGBB and sent to SundaeSwap. This
                ownerless liquidity pools back the value of all BGBB tokens and
                allow anyone to buy or sell large amounts of BGBB at their
                leisure.
              </p>
              <div class="flex flex-wrap text-center">
                <a
                  href="#"
                  target="_self"
                  class="shadow-2xl get-started font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white text-sm"
                >
                  Smart Contract
                </a>

                <a
                  href="#"
                  class="shadow-2xl github-star ml-1 font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-bgbb-1 text-sm"
                  target="_self"
                >
                  SundaeSwap <i class="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Use DeFi Tokens Use DeFi Tokens Use DeFi Tokens Use DeFi Tokens Use DeFi Tokens -->

    <section class="pb-20 relative block bg-bgbb-y">
      <div class="container mx-auto px-4 mobile:pt-12 lg:pt-24 lg:pb-10">
        <div class="w-full lg:w-12/12 md:px-8">
          <h3 class="text-3xl mb-2 leading-normal text-white text-center">
            Use DeFi Tokens for BGBB <br />
            Reservations
          </h3>
          <p
            class="text-xl font-light leading-relaxed my-6 text-white text-center"
          >
            The BGBB Liquidity Transformer will be able to accept <br />
            various tokens and convert them through SundaeSwap into <br />
            ADA for BGBB reservations.
          </p>

          <div class="container mx-auto">
            <div class="flex flex-wrap place-content-center">


              <div class="w-3/12 px-6 pt-4 rounded-lg bg-white mb-4 mx-4 shadow-2xl">
                <img class="align-middle border-none max-w-full" :src="ada_img"/>
                <p class="text-lg font-bold px-6 text-blueGray-700 text-center pt-2 pb-0">
                 ADA
                </p>
              </div>

                <div class="w-3/12 px-6 pt-4 rounded-lg bg-white mb-4 mx-4 shadow-2xl">
                <img class="align-middle border-none max-w-full" :src="cards_img"/>
                <p class="text-sm font-bold px-6 text-blueGray-700 text-center pt-2 pb-0">
                  CARDS
                </p>
              </div>




<!-- 
              <div
                class="w-3/12 px-6 pt-4 rounded-lg bg-white mb-4 mx-4 shadow-2xl"
              >
                <img
                  class="align-middle border-none max-w-full max-w-80-px ml-2"
                  :src="cards_img"
                />
                <p
                  class="text-lg font-bold px-6 text-blueGray-700 text-center pt-2 pb-0"
                >
                  BUSD
                </p>
              </div> -->

<!--               
              <div
                class="w-3/12 px-6 pt-4 rounded-lg bg-white mb-4 mx-4 shadow-2xl"
              >
                <img
                  class="align-middle border-none max-w-full"
                  :src="ada_img"
                />
                <p
                  class="text-lg font-bold px-6 text-blueGray-700 text-center pt-2 pb-0"
                >
                  ADA
                </p>
              </div>
 -->



            </div>
          </div>
        </div>
      </div>
      <!-- <div class="custom-shape-divider-bottom-1623757940">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
    </svg>
</div> -->
    </section>

    <section class="pb-2 mt-12 lg:px-16">
      <div class="container">
        <div class="flex flex-wrap">
          <div class="w-full md:w-6/12 px-4 text-center">
            <div class="flex-auto">
              <img
                class="align-middle border-none max-w-full h-auto rounded-lg"
                :src="Oracle_img"
              />
            </div>
          </div>

          <div class="w-full md:w-6/12 md:px-4 mobile:px-4 text-left  ">
            <div class="pb-6 pt-20 flex-auto">
              <h2 class="text-3xl text-white">Provable Oracle API</h2>

              <p
                class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify mb-12"
              >
                The amount of available BGBB tokens offered on random supply
                days is determined shortly after the end of that day. BGBB
                leverages the Provable Oracle API, which generates randomness
                delivered on-chain in a provable cryptographically secure
                manner.
                <br />
                <br />
                Even the BGBB developers won't know how much supply is offered
                on random supply days until that day ends.
              </p>

              <div class="flex flex-wrap text-center">
                <a
                  href="#"
                  target="_self"
                  class="shadow-2xl font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white text-sm"
                >
                  Smart Contract
                </a>

                <a
                  href="#"
                  class="shadow-2xl ml-1 font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbbnav text-sm"
                  target="_self"
                >
                  Provable Oracle <i class="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- EARN BBY PROMOTING -->

    <section class="pb-20 relative block bg-bgbb-y">
      <div class="custom-shape-divider-top-1623755832">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
      <div class="container mx-auto px-4 lg:pt-24 lg:pb-10">
        <div class="w-full lg:w-12/12 md:px-8 mobile:pt-20">
          <h3 class="text-4xl  mb-6 leading-normal text-white text-center pt-20 ">
            Earn commision for <br />
            promoting BGBB
          </h3>
          <p
            class="text-xl font-light leading-relaxed mt-4 mb-6 text-white text-center"
          >
            The pure design and fair distribution of BGBB create the potential
            for exponential gains over extended stakes, long after other cryptos
            would have failed. Since a pool of ADA backs BGBB, BGBB investors
            experience the safety of the #3 market cap crypto while also having
            the potentially explosive growth of a new project.
            <br /><br /><br />
          </p>
        </div>
      </div>
      <!-- <div class="custom-shape-divider-bottom-1623757940">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
    </svg>
</div> -->
    </section>

    <!-- END EARN BY PROMOTIG END -->

    <section class="pb-20 relative block bg-white">
      <div class="custom-shape-divider-top-1623762225">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>

      <div class="container mx-auto md:px-12 mobile:px-4 lg:pt-4 lg:pb-10 -mt-32">
        <div
          class="relative min-w-0 break-words bg-dark-bgbb100 w-full mb-8 shadow-2xl rounded-lg"
        >
          <div class="px-4 py-5 flex-auto text-center text-white">
            <br />
            <h6 class="text-3xl">Your Referral Link:</h6>
            <br />
            <p class="mt-2 text-xl">
              https://bgbb.io/?w= <span id="account"> </span
              >
              <br />
              <br />
            </p>

            <div class="flex flex-wrap text-center justify-center my-10">
              <a
                href="#"
                target="_self"
                class="shadow-xl font-semibold px-6 py-4 rounded outline-none focus:outline-none bg-white text-base container2 text-bg-bgbb100"
              >
                <i class="fas fa-copy"></i> Copy Link
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="custom-shape-divider-bottom-1623757940">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
    </svg>
</div> -->
    </section>
<div id="quickreservation"></div>
    <section class="pb-20 relative block bg-white">
      <div class="container mx-auto lg:pt-24 lg:pb-10 ">
        <div class="w-full lg:w-12/12 md:px-8 mobile:px-4">
          <br />

          <div class="container mx-auto pb-20 mt-12">
            <div class="flex flex-wrap">
              <div class="w-full md:w-6/12 px-4 text-center">
                <div class="lg:px-10 py-5 flex-auto">
                  <h3 class="text-dark text-xl text-left text-4xl">
                    Connect your wallet
                  </h3>

                  <p
                    class="mt-4 text-lg leading-relaxed text-dark text-justify"
                  >
               
                    Using the BGBB dashboard, you can use supported assets for BGBB reservations and BGBB staking.
                    <br> <br>
                    Funds collected for BGBB reservations are managed by the Uiswap protocol and used to form the initial liquidity pool for future trading.

                  </p>
                </div>
              </div>

              <div class="w-full md:w-6/12 md:px-4 text-center">
                <div class="flex-auto">
                  <div
                    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-2xl rounded-lg bg-gray-300 border-0"
                  >
                    <div class="flex flex-wrap">
                      <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
                        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
                          <form>
                            <div class="flex flex-wrap">
                              <div class="w-full lg:w-12/12 px-4">
                                <div class="relative w-full mb-3">
                                  <h3
                                    class="text-dark text-xl text-left text-4xl mt-8"
                                  >
                                    Quick BGBB Reseration
                                  </h3>
                                </div>
                              </div>

                              <label class="block text-gray-700 text-xs mt-4"
                                >Staking amount
                              </label>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-6"
                                >
                                  <i class="fas fa-wallet"></i>
                                </span>
                                <input
                                  type="number"
                                  placeholder="Staking amount"
                                  class="px-3 py-6 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>

                              <label class="block text-gray-700 text-xs mt-4"
                                >Staking Duration
                              </label>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-6"
                                >
                                  <i class="fas fa-clock"></i>
                                </span>
                                <input
                                  type="text"
                                  placeholder="Staking Duration"
                                  class="px-3 py-6 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>

                              <label class="block text-gray-700 text-xs mt-4">
                                Referral Address
                              </label>
                              <div
                                class="relative flex w-full flex-wrap items-stretch my-2"
                              >
                                <span
                                  class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-lg items-center justify-center w-8 pl-3 py-3"
                                >
                                  <i class="fas fa-user-plus"></i>
                                </span>
                                <input
                                  placeholder="0x00000000...000000"
                                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-base shadow outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                />
                              </div>
                            </div>
                          </form>

                          <div
                            class="flex flex-wrap text-justify my-4 text-gray-600"
                          >
                            <p>
                              <input type="checkbox" /> I would like to open
                              this stake as Insurance Stakes
                              <span class="text-xs bg-gray-300 p-1 font-bold"
                                >APPROVAL REQUIRED</span
                              >
                            </p>
                          </div>

                          <div class="flex flex-wrap text-justify my-4 text-xs">
                            <p>
                              By clicking the
                              <b> Create Regular Stake</b> button below you
                              agree that provided values are accurate and
                              reviewed before the final decision to create stake
                              is made.
                            </p>
                          </div>

                          <div
                            class="flex flex-wrap text-center justify-center"
                          >
                            <a
                              href="#"
                              target="_self"
                              class="shadow-2xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mb-1 bg-dark-bgbb100 uppercase text-sm container"
                            >
                              Create Regular Stake
                            </a>
                          </div>
                        </div>
                      </div>

                      <!-- SUMMARY -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-shape-divider-bottom-1623757940">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </section>

    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";

import FooterComponent from "@/components/Footers/Footer.vue";

// import LaunchDate from "@/components/Cards/LaunchDate.vue";


import LT_img from "@/assets/img/LT.svg";
import Oracle_img from "@/assets/img/oracles.svg";

import cards_img from "@/assets/img/cards_img.svg";

import ada_img from "@/assets/img/ada_img.svg";

import earnandhelp_img from "@/assets/img/earnandhelp.svg";



export default {
  data() {
    return {

      LT_img,
      Oracle_img,  
      ada_img,
      earnandhelp_img,
      cards_img,


};
  },
  components: {
    IndexNavbar,
    FooterComponent,
    // LaunchDate,
  },
};
</script>
